import React, { useState, useEffect } from 'react';
import {
  Button,
  Box,
  Dialog,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { QRCodeSVG } from 'qrcode.react';
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

const ElementLink = () => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [link, setLink] = useState('');
  const projectGuid = useSelector((state) => state.variant.current?.projectGuid);
  const calculationGuid = useSelector((state) => state.variant.current?.calculationGuid);

  useEffect(() => {
    if (projectGuid && calculationGuid) {
      const generatedLink = `https://2dchat.system123.ru/?pr=${projectGuid}&variant=${calculationGuid}`;
      setLink(generatedLink);
    }
  }, [projectGuid, calculationGuid]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const copyLink = () => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(link)
        .then(() => alert(t("elementLink.copied")))
        .catch((err) => console.error(t("elementLink.copyError"), err));
    } else {
      console.warn(t("elementLink.clipboardNotSupported"));
    }
  };

  return (
    <div>
      <Button className="bm-item menu-item" onClick={handleOpen}>
        { t("elementLink.openButton") }
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={false}
        fullWidth
        sx={{ '& .MuiDialog-paper': { maxWidth: '505px' } }}>
        <Box display="flex" justifyContent="space-between" alignItems="center" p={2} mb={-2}>
          <div className="infoList--title">{ t("elementLink.title") }</div>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent sx={{ p: 2 }}>
          <div className="qr-view qr-view--display qr-view--display-view">
            {link && <QRCodeSVG value={link} size={128} />}
            <Box
              mt={2}
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '8px',
              }}>
              <input
                id="copyLink"
                disabled
                value={link}
                style={{ flex: 1, border: 'none', background: 'transparent' }}
              />
              <IconButton onClick={copyLink}>
                <ContentCopyIcon />
              </IconButton>
            </Box>
          </div>
        </DialogContent>
        <DialogActions>
          <button type="button" onClick={handleClose}>
            { t("close") }
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ElementLink;
